/**
 * Keyclic API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.24.5
 * Contact: techies@keyclic.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface ReportStatePatch { 
    transition: ReportStatePatch.TransitionEnum;
}
export namespace ReportStatePatch {
    export type TransitionEnum = 'accept' | 'refuse' | 'hold' | 'progress' | 'close';
    export const TransitionEnum = {
        Accept: 'accept' as TransitionEnum,
        Refuse: 'refuse' as TransitionEnum,
        Hold: 'hold' as TransitionEnum,
        Progress: 'progress' as TransitionEnum,
        Close: 'close' as TransitionEnum
    };
}
